module.exports = __webpack_public_path__ + "media/ischemic colitis.6f1de16c.wav";